import http from '../_http_v2';

const policy = {
  //default
  list: (m) => { return http.post(`console/wmds/policy/list`, m); },
  detail: (m) => { return http.get(`console/wmds/policy/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wmds/policy`, m); },
  update: (m) => { return http.put(`console/wmds/policy`, m); },
  delete: (m) => { return http.delete(`console/wmds/policy/${m.id}`); },

  limit: (m) => { return http.get(`console/wmds/policy/limit`, m); }
}

export default policy

export { policy }